// extracted by mini-css-extract-plugin
export default {"componentWrapper":"AddToShoppingListButton_componentWrapper__b6TjN","shoppingListButton":"AddToShoppingListButton_shoppingListButton__FhTBi"};